export default {
    /**
     * 是否是https
     *
     * @returns {boolean}
     */
    is_https() {
        return "https:" == location.protocol ? true : false;
    },

    /**
     * 获取URL上的参数
     *
     * @param {*} name
     * @returns
     */
    getUrlParam(name) {
        return new URL(window.location.href)?.searchParams?.get(name);
    },

    /**
     * 获取系统默认语言
     *
     * @returns {string}
     */
    defaultLanguage() {
        let lang = navigator.language || navigator.userLanguage;
        return lang.split("-")[0];
    },

    /**
     * 追加或替换URL参数
     *
     * @param {string} url
     * @param {string} key
     * @param {string} value
     * @returns {string}
     */
    appendQueryParam(url, key, value) {
        if (url == undefined || url == "") {
            return url || "";
        }
        const param = `${key}=${value}`;
        const paramReg = new RegExp(`${key}=[^&]+`);
        if (paramReg.test(url)) {
            return url.replace(paramReg, param);
        }
        const separator = url.indexOf("?") >= 0 ? "&" : "?";
        return url + separator + param;
    },

    /**
     * 重定向到第三方页面
     *
     * @param {string} url
     */
    redirectThirdPage(url) {
        var a = document.createElement("a");
        a.href = url;
        a.rel = "noreferrer";
        a.addEventListener("click", function () {
            window.location.href = this.href;
        });
        a.click();
    },
};
